module.exports = __webpack_public_path__ + "static/media/squirrel.2123844d.png";